import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import ContactTopic from './ContactTopic';

const SECTION_PREFIX = 'portal-contact';
const TIMEOUT = 50;

interface WebCat {
	set(name : string, value : string) : void;
}

function getSCSWebchatAPI() : Promise<WebCat> {
	let waitTime = 2500;
	let scs = window.SCS as any;
	if(scs && scs.webchat) {
		return Promise.resolve(scs.webchat);
	}

	return new Promise((resolve, reject) => {
		const interval = setInterval(() => {
			scs = window.SCS;
			if (scs && scs.webchat) {
				clearInterval(interval);
				resolve(scs.webchat);
			} else if (waitTime <= 0) {
				clearInterval(interval);
				reject(new Error('window.SCS.webchat is not available after 2.5s'));
			}
			waitTime -= TIMEOUT;
		}, TIMEOUT);
	});
}

export default class GenesysChatForContact extends Module {
	private topicId! : string;

	public on(callback : Hook) {
		this.topicId = this.$ctx.closest('.result[data-parent-topic]').data('parent-topic');

		callback();
	}

	public async onTopicSelected(topic : ContactTopic) {
		if (topic.topicName !== this.topicId && (topic as any).name !== this.topicId) {
			return;
		}

		const name = topic.topicName || (topic as any).name;
		const topicName = name.split('/');
		try {
			const webChat = await getSCSWebchatAPI();
			// Check if topic is still a currently selected one
			if(!topic.isCurrent()) {
				return;
			}

			if (topicName[0]) {
				webChat.set(`${SECTION_PREFIX}:topic`, topicName[0]);
			}
			if (topicName[1]) {
				webChat.set(`${SECTION_PREFIX}:subtopic`, topicName[1]);
			}
		} catch(e) {
			this.log.error(e.message);
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/Tc.Module.GenesysChatForContact.ts